import { ReactGridContainer } from '@europrocurement/flexy-components';
import DashboardStatCard from '@europrocurement/flexy-components/components/molecules/DashboardStatCard/DashboardStatCard';
import { DossierOpenSearchJsonldOpensearchDossierStatutRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { getDossierStatus } from '@europrocurement/l2d-modules/modules/Dossiers';
import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { type ResizeHandleAxis } from 'react-grid-layout';

type DossierStatusWidgetDashboardProps = {
    statusDossierOpenSearch: DossierOpenSearchJsonldOpensearchDossierStatutRead[];
    handleDossierStatusClick: (statutId?: number | null) => void;
};
const DossierStatusWidgetDashboard: React.FunctionComponent<DossierStatusWidgetDashboardProps> =
    function ({ statusDossierOpenSearch = [], handleDossierStatusClick }) {
        const [statusDossiers, setStatusDossiers] =
            useState<DossierOpenSearchJsonldOpensearchDossierStatutRead[]>(getDossierStatus()); // Empty list of Dossier status with a count as 0

        const maxXindexCard = 6;
        const currentXIndexCard = useRef(-1);
        const currentYIndexCard = useRef(0);

        useEffect(() => {
            setStatusDossiers(
                getDossierStatus().map((statusDossier) => ({
                    ...statusDossier,
                    childsCount: statusDossierOpenSearch.find(
                        (statusOpenSearch) => statusOpenSearch.id === statusDossier.id,
                    )
                        ? statusDossierOpenSearch.find(
                              (statusOpenSearch) => statusOpenSearch.id === statusDossier.id,
                          )?.childsCount
                        : statusDossier.childsCount,
                })),
            );
        }, [statusDossierOpenSearch]);

        return (
            <ReactGridContainer
                localStorageName="grid-status-dossier-formalist"
                gridconfig={{ cols: 6, rowHeight: 30 }}
                currentXIndexCard={currentXIndexCard}
                currentYIndexCard={currentYIndexCard}
                // loop thru status dossier to generate a layout of key and position in react grid
                layoutProps={[
                    ...statusDossiers.map((statusDossier, i) => {
                        if (i !== 0 && i % maxXindexCard === 0) {
                            currentXIndexCard.current = -1;
                            currentYIndexCard.current++;
                        }
                        currentXIndexCard.current++;
                        return {
                            i: `dossier_status_${(statusDossier.id as number).toString()}`,
                            x: currentXIndexCard.current,
                            y: currentYIndexCard.current,
                            w: 1,
                            h: 2,
                            isResizable: true,
                            resizeHandles: [
                                's',
                                'w',
                                'e',
                                'n',
                                'sw',
                                'nw',
                                'se',
                                'ne',
                            ] as ResizeHandleAxis[],
                        };
                    }),
                ]}
            >
                {statusDossiers.map((statusDossier) => (
                    <Box key={`dossier_status_${(statusDossier.id as number).toString()}`}>
                        <DashboardStatCard
                            count={statusDossier.childsCount || 0}
                            libelle={statusDossier.libelle as string}
                            onClick={() => handleDossierStatusClick(statusDossier.id)}
                        />
                    </Box>
                ))}
            </ReactGridContainer>
        );
    };

export default DossierStatusWidgetDashboard;
